<template>
  <div class="ecm__dialog-delete">
    <el-dialog :title="message" :visible.sync="isShow" :show-close="false">
      <div class="ecm__dialog-delete__content">
        <i class="fas fa-exclamation-circle"></i>
      </div>
      <div class="ecm__dialog-delete__footer">
        <button @click="isShow = false">Cancel</button>
        <button @click="handleYes">Yes sure</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Delete_Item',
  props: {
    message: {
      type: String,
      default: 'Are you sure you want to delete'
    }
  },
  data () {
    return {
      isShow: false,
      type: null
    }
  },
  methods: {
    setIsShow (payload, type = null) {
      this.$data.isShow = payload
      if (type) {
        this.type = type 
      }
    },
    handleYes () {
      this.$data.isShow = false
      if (this.$data.type === 'all') {
        this.$emit('handleDeleteItems')
      } else {
        this.$emit('handleDeleteItem')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__dialog-delete {
  position: absolute;
  &::v-deep .el-dialog__wrapper {
    .el-dialog {
      width: 25%;
      border-radius: 7px;
      .el-dialog__header {
        text-align: center;
        font-weight: 500;
      }
      .el-dialog__body {
        padding: 0 0 20px 0;
        .ecm__dialog-delete__content {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .fa-exclamation-circle {
            font-size: 50px;
            color: rgba(255, 0, 0, 0.734);
          }
        }
        .ecm__dialog-delete__footer {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          button {
            border-radius: 5px;
            cursor: pointer;
            &:first-child {
              margin-right: 5px;
              background: rgba(255, 255, 255, 0.905);
              color: var(--color-blue-background);
            }
            font-size: 15px;
            font-weight: 500;
            color: white ;
            background: var(--color-blue-background);
            border: none;
            outline: none;
            padding: 7px 15px;
          }
        }
      }
    }
  }
}
</style>
